<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .add-notes {
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(8px);

    .dropdown-row {
      display: flex;
      align-items: center;
      border-radius: utils.in_rem(10px);
      padding: utils.in_rem(2px);
      width: fit-content;
      @include colors.background-color("interfaceSwGrey_10");

      .label {
        width: 120px;
        @include mixins.body2();
        padding: 0 utils.in_rem(14px);
      }
    }
  }
</style>

<script>
  import SingleSelectDropdown from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/SingleSelectDropdown/SingleSelectDropdown.svelte";
  import SettingToggle from "../../../components/shared/SettingToggle.svelte";
  import { integrationStore } from "../../../stores";

  $: enabled = $integrationStore.getValue("addNotetakerMeetings");

  export let addNotesSettings;

  const addNotetakerSetting = addNotesSettings.find(
    (setting) => setting.key === "addNotetakerMeetings"
  );

  $: ({ title, key, values } = addNotesSettings.find(
    (setting) => setting.key === "notetakerAddMethod"
  ));

  $: items = values.map((item) => ({
    id: item.val,
    value: item.val,
    label: item.key,
  }));

  $: storeValue = $integrationStore.getValue(key);
  $: selected = storeValue;
  $: if (selected !== storeValue) {
    $integrationStore.setValue(key, selected);
  }
</script>

<div class="add-notes">
  <SettingToggle setting={addNotetakerSetting} />
  {#if enabled}
    <div class="dropdown-row">
      <div class="label">
        <span>{title}</span>
      </div>
      <SingleSelectDropdown
        style="width:246px; height: 2.5rem;"
        size="large"
        {items}
        bind:selected
        placeholder="Select one"
      />
    </div>
  {/if}
</div>
